// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__FbaWC","header":"MergedInvoice_header__2ELhd"};